import React from "react";
import OurServices from "../OurServices";

function Epabx() {
  return (
    <div>
      <OurServices
        hero_title={"EPABX"}
        hero_desc={
          "Your trusted partner in innovative security and office automation solutions."
        }
        about_img_one={
          "https://res.cloudinary.com/ddffnw81j/image/upload/v1743236694/epabx-1_ioggkp.png"
        }
        about_img_one_desc={
          "EPABX (Electronic Private Automatic Branch Exchange) is a private telephone network used within organizations to facilitate seamless internal and external communication. It functions as an automated switchboard, connecting multiple internal extensions while allowing selected lines to connect to the external public telephone network (PSTN)."
        }
        about_img_two={
          "https://res.cloudinary.com/ddffnw81j/image/upload/v1743236697/epabx-2_g1gila.png"
        }
        about_img_two_desc={
          "EPABX serves as an intermediary system between multiple telephone lines and extensions. When a call is made from one extension to another, the EPABX system automatically routes the call without requiring manual intervention. Similarly, when an external call is received, it is directed to the appropriate extension or department based on predefined settings."
        }
        why_desc={
          "Our EPABX systems are designed to meet the needs of businesses of all sizes. From small offices to large enterprises, we provide tailored solutions that ensure smooth communication, cost-efficiency, and improved collaboration."
        }
        s_one={"EPABX System Installation"}
        s_two={"System Configuration & Customization"}
        s_three={"Ongoing Maintenance & Support"}
        s_four={"Scalable Upgrades for Growing Businesses"}
        f_one_title={"Customizable Features"}
        f_one_desc={
          "Our EPABX systems come with customizable features such as call forwarding, voicemail, conference calling, and automated attendants. You can tailor the system to meet the unique needs of your business."
        }
        f_two_title={"Scalable Solutions"}
        f_two_desc={
          "Whether you are a small office or a large enterprise, our EPABX systems are scalable. We can expand your system as your business grows, ensuring that you always have the communication tools you need."
        }
        f_three_title={"Cost-Effective Communication"}
        f_three_desc={
          " With EPABX, you can significantly reduce the costs of communication within your office and with external parties. By using internal extensions, you can eliminate long-distance charges and streamline communication."
        }
        f_four_title={"Reliable Support"}
        f_four_desc={
          "We offer comprehensive support for all our EPABX systems, including installation, maintenance, and troubleshooting. Our team ensures that your system runs smoothly at all times."
        }
        c_one_title={"Serving a Wide Range of Clients"}
        c_one_desc={
          " Vitri Enterprises provides EPABX solutions to a diverse range of clients, from small businesses to large enterprises. Whether you need a small-scale system for a team or a large, integrated communication system, we have the expertise to deliver the perfect solution."
        }
        c_two_title={"Enhance Communication with Vitri Enterprises Today!"}
        c_two_desc={
          "Make your office communication efficient and cost-effective with our advanced EPABX solutions. Get in touch with Vitri Enterprises to learn more about how we can help streamline your business communications."
        }
      />
    </div>
  );
}

export default Epabx;
